import * as React from "react";

export const Exit: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <g
      stroke="#D6453B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      clipPath="url(#clip0_16612_24535)"
    >
      <path d="M6.667 4.167H5c-.92 0-1.666.745-1.666 1.666v8.334c0 .92.745 1.666 1.666 1.666h1.667M11.193 17.46l4.167-.92a1.666 1.666 0 0 0 1.307-1.627V5.088c0-.782-.543-1.46-1.308-1.628l-4.166-.92a1.666 1.666 0 0 0-2.026 1.628v11.665c0 1.065.986 1.857 2.026 1.627M11.667 9.167v1.666"></path>
    </g>
    <defs>
      <clipPath id="clip0_16612_24535">
        <path fill="#fff" d="M0 0h20v20H0z"></path>
      </clipPath>
    </defs>
  </svg>
);
